import { useVeltClient } from '@veltdev/react';
import React, { useEffect } from 'react'

function YourAuthenticationComponent() {

    const { client } = useVeltClient();

    useEffect(() => {
        identifyUser();
    }, [client]);

    const identifyUser = async () => {
        if (client) {
            let user = {
                userId: `1`,
                name: `User 1`,
                email: `user1@velt.dev`,
                photoUrl: `https://i.pravatar.cc/150?img=1`
            };

            await client.identify(user);
        }
    };

    return (
        <></>
    )
}

export default YourAuthenticationComponent;